import Loading from '~components/dumbs/Loading';
import Text from '~components/dumbs/Text';
import * as Styled from './styles';

function FullScreenLoading({ text }: { text?: string }) {
  return (
    <Styled.Wrapper>
      <Loading />
      {text && <Text>{text}</Text>}
    </Styled.Wrapper>
  );
}

export default FullScreenLoading;
